import { IconProps, NocIconGenerator } from '../common';

export const ArrowRight3 = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'ArrowRight3',
            path: (
                <path
                    d="M13.3454 12L7.5 5.7L9.07732 4L16.5 12L9.07732 20L7.5 18.3L13.3454 12Z"
                    fill="#212121"
                />
            ),
        }}
    />
);
